module.exports = __webpack_public_path__ + "img/payments-logo.c86b035c.png";